import { f7 } from "framework7-vue";

const INTENT_URL_KEY = "avocashIntentUrl";

function getStorage() {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function getIntentUrl() {
  const storage = getStorage();
  if (!storage) return "";
  try {
    return storage.getItem(INTENT_URL_KEY) || "";
  } catch {
    return "";
  }
}

export function setIntentUrl(url) {
  const storage = getStorage();
  if (!storage) return;
  if (!url || url === "/") return;
  try {
    storage.setItem(INTENT_URL_KEY, url);
  } catch {
    // ignore storage failures (private mode, quota, etc.)
  }
}

export function clearIntentUrl() {
  const storage = getStorage();
  if (!storage) return;
  try {
    storage.removeItem(INTENT_URL_KEY);
  } catch {
    // ignore storage failures
  }
}

export function captureIntentUrl() {
  const route = f7.views?.main?.router?.currentRoute;
  if (!route) return;
  const url = route.url || route.path;
  if (url && url !== "/") {
    setIntentUrl(url);
  }
}

export function getCurrentUrl() {
  try {
    const route = f7.views?.main?.router?.currentRoute;
    const url = route?.url || route?.path || "";
    if (url) return url;
  } catch {
    // fall through to location
  }
  return (window.location.pathname || "/") + (window.location.search || "");
}

export function isAtIntentUrl() {
  const intent = getIntentUrl();
  if (!intent) return false;
  const current = getCurrentUrl();
  return current === intent || current.startsWith(intent);
}
